export enum UploadStatus {
    READY_FOR_UPLOAD = 'READY_FOR_UPLOAD',
    UPLOADED = 'UPLOADED',
    AV_SCAN_DONE = 'AV_SCAN_DONE',
    AV_SCAN_FAILED = 'AV_SCAN_FAILED',
    PENDING_CONFIRMATION = 'PENDING_CONFIRMATION',
    PROCESSING = 'PROCESSING',
    DATA_PARSED = 'DATA_PARSED',
    PARSING_FAILED = 'PARSING_FAILED',
    USER_CANCELLED = 'USER_CANCELLED'
}
